import {
	DBConnectorConfig,
	dbConnectorPrefix,
	DBTestPayload,
	FlowConfig,
	testConnectionPath,
	urlCombine,
} from 'ihub/common';
import { handleResponse, microServiceAPI, standardPost } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';

export class DBConnectorHttpService {
	async testConnection(item: DBConnectorConfig, flow: FlowConfig, options?: HttpResponseOptions) {
		const payload: DBTestPayload = { item, flow };
		const url = urlCombine(microServiceAPI, dbConnectorPrefix, testConnectionPath);
		const response = await standardPost(url, payload);
		await handleResponse(response, 'Test Connection', dbConnectorPrefix, options);
	}
}
